import AbstractTool from "../AbstractTool";
import SelectionMenu from "../SelectionMenu";

export default class SelectTool extends AbstractTool {
    selectedPlant = null;
    scrollEnabled = true;
    menu = new SelectionMenu(this.provider);

    moveMouse() {
        let hovered = this.elements.hovered();
        hovered ? this.cursor.pointer() : this.cursor.move();
        this.hoverSet.set(hovered);
    }

    pressMouseOnCanvas() {
        if (this.menu.initialized) {
            this.menu.remove();
            return;
        }
        if (this.p.mouseButton === this.p.RIGHT) {
            let hovered = this.elements.hoveredAll();
            if (hovered.length <= 1) {
                this.clickMouseOnCanvas();
                return;
            }
            this.menu.refresh(hovered);
            return;
        }
    }

    dragMouse(event) {
        if (event.target.id == 'defaultCanvas0') {
            this.dragging = true;
            this.cursor.grabbing();
            this.view.move(
                this.p.movedX || (this.p.mouseX - this.p.pmouseX),
                this.p.movedY || (this.p.mouseY - this.p.pmouseY)
            );
        }
    }

    clickMouseOnCanvas() {
        if (this.dragging) {
            this.dragging = false;
            return;
        }
        let selectedElement = this.elements.hovered();
        if (selectedElement) {
            if (selectedElement.selected) {
                this.selection.remove(selectedElement);
            } else {
                this.selection.select(selectedElement);
            }
            this.sideBar.setTab('info');
        } else {
            this.selection.reset();
        }
    }

    activate() { }

    deactivate() {
        this.menu.remove();
        this.selection.reset();
    }

    pressKey(code) {
        switch (code) {
            case 37: // left arrow
                view.move(this.arrowMove, 0);
                return;
            case 38: // up arrow
                view.move(0, this.arrowMove);
                return;
            case 39: // right arrow
                view.move(-this.arrowMove, 0);
                return;
            case 40: // down arrow
                view.move(0, -this.arrowMove);
                return;
        }
    }
}
